export default "__VITE_ASSET__CToCEo91__"